import { useTranslation } from 'react-i18next';

import { getImageUrl } from '@/utils/dedaloUtils';

function Documents({ documents }) {
    const { t } = useTranslation();

    return (
        <div className="has-background-light p-7 radius flow">
            <h3>{t('documentos')}</h3>

            <div className="py-5">
                <ul
                    className="documents-gallery list-reset pswp-gallery link-dn"
                    id="documents-gallery"
                >
                    {documents &&
                        documents.length > 0 &&
                        documents.map((item, i) => {
                            const pdfUrl = getImageUrl(item.document);
                            const imageUrl = pdfUrl.replace('.pdf', '.jpg').replace('web', 'thumb');
                            return (
                                <li key={'document-' + i} className="is-size-7 full-link">
                                    <div className="img-container">
                                        <img src={imageUrl} alt={item.title} className="radius" />
                                    </div>
                                    <a href={pdfUrl} target="_blank">
                                        {item.title}
                                    </a>
                                </li>
                            );
                        })}
                </ul>
            </div>
        </div>
    );
}

export default Documents;
